<mat-form-field appearance="fill" class="wide-select">
  <mat-label>{{ label }}</mat-label>
  <mat-select (selectionChange)="onOptionChange($event)" [disabled]="loading || docs.length === 0">
    @for (doc of docs; track doc._id) {
      <mat-option [value]="doc._id">{{ doc.title }}</mat-option>
    }
  </mat-select>
</mat-form-field>

@if (loading) {
  <div class="spinner-container">
    <mat-spinner diameter="36"></mat-spinner>
  </div>
}

@if (!loading && docs.length === 0) {
  <p class="no-docs">No documents available.</p>
}

@if (resolving) {
  <div class="spinner-container">
    <mat-spinner diameter="28"></mat-spinner>
  </div>
}

@if (error) {
  <p class="error-message">{{ error }}</p>
}

@if (selectedOption || selectedImage) {
  <div class="section-display">
    @if (selectedOption) {
      <iframe #pdfViewer [src]="selectedOption" width="700" height="840" frameborder="0" scrolling="no"></iframe>
    }
    @if (selectedImage) {
      <img #imageViewer [src]="selectedImage" width="900" height="auto" style="display:block; margin:auto;" alt="Selected document">
    }
  </div>
}
